import { render, staticRenderFns } from "./AddEditProductModal.vue?vue&type=template&id=1dd74891&scoped=true&"
import script from "./AddEditProductModal.vue?vue&type=script&lang=js&"
export * from "./AddEditProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd74891",
  null
  
)

export default component.exports